import styled from 'styled-components';

import colors from '../../assets/colors';
import { Typography } from '../typography';

interface IPropsStatusText {
	color: keyof typeof colors;
	background: keyof typeof colors;
}

const Row = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	padding: 20px 0;
	border-bottom: 1px solid #bfbdb7;
	width: 100%;

	&:last-child {
		border-bottom: none;
	}
`;

const LeftPart = styled.div`
	display: flex;
	align-items: center;
	flex: 1;
`;

const RightPart = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex: 1;
`;

const StatusText = styled(Typography)<IPropsStatusText>`
	//padding: 6px 10px;
	//border-radius: 10px;
	color: ${p => p.theme.colors[p.color]};
	// background-color: ${p => p.theme.colors[p.background]};
`;

const Button = styled.button`
	background-color: ${p => p.theme.colors.black};
	width: 87px;
	height: 35px;
	align-items: center;
	border-radius: 60px;
`;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	Row,
	LeftPart,
	RightPart,
	Button,
	StatusText,
};
